<template>
  <q-page>
    <div class="q-pa-md">
     <div class="text-h4">Actualizar Base de Datos</div>
     <label>Analitico - 731
        <input type="file" id="file" ref="file" accept=".csv" v-on:change="onChangeFileUpload()"/>
      </label>
      <div>
        <div class="q-pa-md q-gutter-sm float-left">
          <q-btn color="primary" label="Guardar" type="button" v-on:click="submitForm()"/>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>

import http from "@/services/http"

 export default {
    data(){
      return {
        file: ''
      }
    },
  
    methods: {
      async submitForm(){
            let formData = new FormData();
            formData.append('file', this.file);
            await http.postFile('actualizacion/actualizar',formData)
      },
  
      onChangeFileUpload(){
        this.file = this.$refs.file.files[0];
      }
    }
  }

</script>